import { logInfo } from './utils/logging';

class Settings {
    constructor() {
        this.appUrl = Settings.requireEnv('REACT_APP_URL');
        this.metadataName = Settings.requireEnv('REACT_APP_METADATA_NAME');

        // Service URLs
        this.sttServiceUrl = Settings.requireEnv('REACT_APP_STT_URL');
        this.identityServiceUrl = Settings.requireEnv('REACT_APP_IDENTITY_URL');

        // Stripe
        this.stripePublishableKey = Settings.requireEnv('REACT_APP_STRIPE_PUBLISHABLE_KEY')

        // STT
        //this.maxAudioDuration = parseInt(process.env.REACT_APP_MAX_AUDIO_DURATION, 10) || 60 * 60; // 1 hour in seconds
        const maxFileSizeEnv = Settings.getEnv('REACT_APP_MAX_FILE_SIZE');
        this.maxFileSize = maxFileSizeEnv ? parseInt(maxFileSizeEnv, 10) : 1024 * 1024 * 1024; // Default: 1GB

        // HTTP Request timeout (in milliseconds)
        const timeoutEnv = Settings.getEnv('REACT_APP_REQUEST_TIMEOUT');
        this.requestTimeout = timeoutEnv ? parseInt(timeoutEnv, 10) : 30000; // Default: 30 seconds

        // File upload timeout (in milliseconds) - longer than regular requests
        // For TUS uploads, this timeout applies per chunk, so large files can take longer overall
        const uploadTimeoutEnv = Settings.getEnv('REACT_APP_UPLOAD_TIMEOUT');
        this.uploadTimeout = uploadTimeoutEnv ? parseInt(uploadTimeoutEnv, 10) : 300000; // Default: 5 minutes (increased for large files)

        // TUS threshold (in bytes) - switch to TUS for large files
        const tusThresholdEnv = Settings.getEnv('REACT_APP_TUS_THRESHOLD_BYTES');
        this.tusThresholdBytes = tusThresholdEnv ? parseInt(tusThresholdEnv, 10) : 20 * 1024 * 1024; // Default: 20MB

        // App/security
        //this.accessTokenExpireMinutes = parseInt(Settings.getEnv('REACT_APP_ACCESS_TOKEN_EXPIRE_MINUTES'), 10) || 30;

        // Sentry
        this.sentryDsn = Settings.getEnv('REACT_APP_SENTRY_DSN');
        const sentryRateEnv = Settings.getEnv('REACT_APP_SENTRY_TRACES_SAMPLE_RATE');
        this.sentryTracesSampleRate = sentryRateEnv ? Number(sentryRateEnv) : undefined;

    }

    getInternalSttServiceUrl() {
        return this.sttServiceUrl;
    }

    getInternalIdentityServiceUrl() {
        return this.identityServiceUrl;
    }

    static getEnv(name) {
        return (window.__env__ && window.__env__[name]) || process.env[name];
    }

    static requireEnv(name) {
        const value = Settings.getEnv(name);
        if (!value) {
            throw new Error(`Missing required environment variable: ${name}`);
        }
        return value;
    }
}

export const getSettings = () => {
    return settings;
};

export const getSttServiceUrl = () => {
    return getSettings().getInternalSttServiceUrl();
};

export const getIdentityServiceUrl = () => {
    return getSettings().getInternalIdentityServiceUrl();
};

export const getMaxFileSize = () => {
    return getSettings().maxFileSize;
};

export const getRequestTimeout = () => {
    return getSettings().requestTimeout;
};

export const getUploadTimeout = () => {
    return getSettings().uploadTimeout;
};

export const getTusThresholdBytes = () => {
    return getSettings().tusThresholdBytes;
};

export const getStripePublishableKey = () => {
    return getSettings().stripePublishableKey;
};

export const getMaxAudioDuration = () => {
    return getSettings().maxAudioDuration;
};

export const getAccessTokenExpireMinutes = () => {
    return settings.accessTokenExpireMinutes;
};

export const getAppUrl = () => {
    return settings.appUrl;
};



// Create a single, cached instance of the settings, similar to Python's get_settings().
const settings = new Settings();

// Log the environment and configuration for debugging purposes.
logInfo('Configuration loaded:', settings);